import React, { useEffect, useState } from 'react';
import '../App.css';
import Layout from '../components/Layout';

const SmartSupport = () => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const contentSections = [
    {
      title: '一站式服务大厅',
      content: '一网通办平台既是学校用户一站式申办各类校园服务的办事大厅，也是管理者一体化审批的流程管理窗口，该平台通过全面集成并无缝对接智慧校园所有提供业务办理的系统功能，实现各系统间数据的互通共融，为师生提供了统一、标准、全面、便捷的一体化智能服务大厅，全面覆盖各类申请、预约、申诉及综合类业务。同时基于业务办理协同化、流程管理定制化、办事指南规范化、审查工作细致化，深化一体化的信息流转与共享，实现校园服务网上办、掌上办，形成综合学生成长、教师发展、网上办事于一体的新型校园服务体系，实现“一网通办”。',
      img: <img src="/src/img/yzsfwdt.png" alt="" />
    },
    {
      title: '统一门户',
      content: '学校系统只需通过一个门户或网页，就可以轻松访问各种功能和服务，无需记住多个应用的账号和密码。统一移动门户可以根据用户的角色、需求和偏好进行个性化定制。用户可以根据自己的工作或学习需求，选择在门户首页展示常用的应用和功能，隐藏不常用的内容，提高操作的便捷性。',
      img: <img src="" alt="" />
    },
    {
      title: '电子签平台',
      content: '电子签署平台是实现线上电子签署及印章管控的信息化平台，它能无缝集成业务系统，并快速赋予业务系统电子签署能力。电子签章平台可以助力学校文件审批、签署、归档全程线上化，实现组织全程数字化最后一公里。包含：教务、学工、后勤、财务、人事等全校各部门的线上签署需求，减少全校师生跑腿量，提高办事效率，全面优化业务流程。',
      img: <img src="/src/img/dzqpt.png" alt="" />
    },
    {
      title: '低代码平台',
      content: '低代码平台支撑校园应用构建，低代码开发平台提供基于模型驱动和组件化架构设计的开发环境，内置可视化、拖拉拽式的建模开发工具和适应多种开发场景的开发框架，提供覆盖学校核心业务系统涉及的开发内容要素的模型体系。',
      img: <img src="/src/img/ddmpt.png" alt="" />
    },
    {
      title: '统一认证授权平台',
      content: '统一的身份认证机制使得登录更加便捷，通常可以采用单点登录（SSO）技术，用户登录一次后即可访问所有授权的应用。对于学校的师生来说，登录校园统一认证平台后，能够方便地进入选课系统、图书馆系统、教学管理系统等，避免了重复登录的繁琐操作。平台对所有接入的应用系统的用户权限进行集中管理和控制。管理员可以在统一的界面上为不同用户或用户组分配相应的应用访问权限和操作权限。',
      img: <img src="/src/img/tyrzsq.png" alt="" />
    },
    {
      title: '大数据管理平台',
      content: '数据治理与共享交换平台：建立学校全量数据中心，同时帮助学校建立部门间的信息资源目录，通过建立数据治理规范标准体系、打通数据孤岛，提供常态化数据质量监控服务和校园数据典型应用。',
      img: <img src="/src/img/dsjglpt.png" alt="" />
    },
    {
      title: '领导驾驶舱',
      content: '通过领导驾驶舱，校领导可以实时监测学校的各项关键指标和数据，包括学生人数、教师队伍、学术成果、财务状况、教学质量等。这些数据以图表、图形、仪表板等形式展示在一个界面上，使领导能够快速、直观地了解学校的整体情况。领导驾驶舱帮助学校领导做出更精准的决策，及时发现问题和机会，并采取相应的行动。它提供了一个全局视图，使领导能够更好地把握学校的发展方向，协调各部门之间的工作，优化资源配置，提高教学质量和管理效率。',
      img: <img src="" alt="" />
    }
  ];

  const handleSectionChange = (index) => {
    setActiveSection(index);
  };

  return (
    <Layout>
      <div className="page-header" style={{ 
        backgroundImage: 'url("/src/img/zhmkt.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>智慧支撑系统</h1>
      </div>
        <div className="page-layout">
          <div className="left-menu">
            {contentSections.map((section, index) => (
              <div
                key={index}
                className={`menu-item ${activeSection === index ? 'active' : ''}`}
                onClick={() => handleSectionChange(index)}
              >
                {section.title}
              </div>
            ))}
          </div>
          <div className="content-section">
            <div className="section-header" style={{
              padding: '20px 40px',
              marginBottom: '30px'
            }}>
              <h3 style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                color: '#333',
                textIndent: '2em'
              }}>{contentSections[activeSection].content}</h3>
            </div>
            <div className="support-content">
              <div className="support-features" style={{ display: 'flex', justifyContent: 'center', height: '500px', marginBottom: '40px' }}>
                <div style={{ width: '1000px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {contentSections[activeSection].img && React.cloneElement(contentSections[activeSection].img, {
                    style: { width: '100%', height: '100%', objectFit: 'contain' }
                  })}
                </div>
              </div>
            </div>
          </div>
      </div>
    </Layout>
  );
};

export default SmartSupport;